import borders from "../../base/borders";
import colors from "../../base/colors";

import pxToRem from "../../functions/pxToRem";
import linearGradient from "../../functions/linearGradient";

const { borderWidth } = borders;
const { transparent, primary, grey } = colors;

const radio = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      padding: pxToRem(6),

      "& .MuiSvgIcon-root": {
        width: pxToRem(18),
        height: pxToRem(18),
        color: transparent.main,
        border: `${borderWidth[1]} solid ${grey[500]}`,
        borderRadius: "50%",
      },

      "&:after": {
        transition: "opacity 120ms ease",
        content: `""`,
        position: "absolute",
        width: pxToRem(10),
        height: pxToRem(10),
        borderRadius: "50%",
        backgroundImage: linearGradient(primary.main, primary.main),
        opacity: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto",
      },

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-focusVisible": {
        outline: `${borderWidth[2]} solid ${primary.main}`,
        outlineOffset: pxToRem(1),
      },
    },

    colorPrimary: {
      color: grey[500],

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          borderColor: primary.main,
        },

        "&:after": {
          opacity: 1,
        },
      },
    },

    colorSecondary: {
      color: grey[500],

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          borderColor: primary.main,
        },

        "&:after": {
          opacity: 1,
        },
      },
    },
  },
};

export default radio;
